import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-userCenter',
  templateUrl: './userCenter.component.html',
  styleUrls: ['./userCenter.component.css']
})
export class UserCenterComponent implements OnInit {

  constructor() {
    const userInfo = sessionStorage.getItem('userInfo');
    if (userInfo !== null) {
      try {
        this.userInfo = JSON.parse(userInfo);
      } catch (err) { }
    }
  }

  userId = '';
  userInfo: any = {};

  ngOnInit() {
    const token: string = sessionStorage.getItem('token') || '';
    if (token.length !== 0) {
      this.userId = this.userInfo.loginName;
    }
  }

}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/components/userCenter/userCenter/userCenter.component.ts